import React from "react";

interface TextFieldProps {
    value: string;
    placeholder: string;
    onChange: (val: string) => void;
}

const TextField = ({ value, onChange, placeholder }: TextFieldProps) => {
    return (
        <input
            value={value}
            placeholder={placeholder}
            onChange={({ target: { value } }) => onChange(value)}
            style={{ paddingLeft: "1vw", border: "2px solid #60CCFF", borderRadius: "10px", minWidth: "35vw", minHeight: "5vh", fontSize: "1vw" }}
        />
    );
};

export default TextField;
